import { render, staticRenderFns } from "./OutboundMappingsCustomisation.vue?vue&type=template&id=117ffc4e&"
import script from "./OutboundMappingsCustomisation.vue?vue&type=script&lang=ts&"
export * from "./OutboundMappingsCustomisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports